import React from 'react';
import './BackgroundCover.css';
import { isMobile, isMobileOrTablet } from '../../utils/appUtils';

interface BackgroundCoverProps {
  backgroundImage?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
  backgroundHeight?: number;
  isWatchPage?: boolean
  className?: string;
  imagePosition?: string;
  bgImgRef?: React.RefObject<HTMLDivElement>
}

const BackgroundCover: React.FC<BackgroundCoverProps> = ({
  backgroundImage,
  backgroundColor,
  children,
  backgroundHeight,
  isWatchPage,
  className = '',
  imagePosition,
  bgImgRef
}) => {
  return (
    <div
      ref={bgImgRef}
      className={`background-cover ${className}`}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        backgroundColor: backgroundColor || 'transparent',
        opacity: isWatchPage ? '' : '',
        minHeight: backgroundHeight ? `${backgroundHeight}px` : '100vh',
        backgroundPosition: imagePosition ? imagePosition : 'center',
        marginTop: isMobile() ? '60px' : '0'
      }}
    >
      {/* <div className="background-overlay"></div> */}
      {children}
    </div>
  );
};

export default BackgroundCover;
